import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';
import { AmountUtils } from 'app/rm/erp/common/utils/amount-utils';
import { EstimatedCosts } from '../../model/estimatedcosts';
@Component( {
    selector: 'erp-businesstripapplication-estimated-costs',
    templateUrl: './businesstripapplication-estimated-costs.component.html'
} )
export class BusinesstripApplicationEstimatedCostsComponent implements OnChanges {
    @Input() estimatedCosts: EstimatedCosts = new EstimatedCosts();
    @Output() readonly estimatedCostsChange: EventEmitter<EstimatedCosts> = new EventEmitter<EstimatedCosts>();

    public sumOfEstimatedCostsFormatted?: number | string;

    constructor( private amountUtils: AmountUtils, ) { }

    onModelChange( changedValue: number ) {
        this.estimatedCosts.sumOfEstimatedCosts = 0;
        if ( this.estimatedCosts.accommodationExpenses !== undefined ) {
            this.estimatedCosts.sumOfEstimatedCosts = this.estimatedCosts.sumOfEstimatedCosts + this.estimatedCosts.accommodationExpenses;
        }

        if ( this.estimatedCosts.conferenceFee !== undefined ) {
            this.estimatedCosts.sumOfEstimatedCosts = this.estimatedCosts.sumOfEstimatedCosts + this.estimatedCosts.conferenceFee;
        }

        if ( this.estimatedCosts.transportationCosts !== undefined ) {
            this.estimatedCosts.sumOfEstimatedCosts = this.estimatedCosts.sumOfEstimatedCosts + this.estimatedCosts.transportationCosts;
        }

        if ( this.estimatedCosts.otherEstimatedCosts !== undefined ) {
            this.estimatedCosts.sumOfEstimatedCosts = this.estimatedCosts.sumOfEstimatedCosts + this.estimatedCosts.otherEstimatedCosts;
        }

        if ( this.estimatedCosts.sumOfEstimatedCosts !== undefined ) {
            this.sumOfEstimatedCostsFormatted = this.amountUtils.getFormattedAmount( this.estimatedCosts.sumOfEstimatedCosts );
        }

        if ( this.estimatedCosts.accommodationExpenses === null &&
            this.estimatedCosts.conferenceFee === null &&
            this.estimatedCosts.transportationCosts === null &&
            this.estimatedCosts.otherEstimatedCosts === null ) {
            this.sumOfEstimatedCostsFormatted = undefined;
        }

        this.estimatedCostsChange.emit( this.estimatedCosts );
    }

    ngOnChanges( changes: SimpleChanges ) {
        // Necessary if inputvalue has values to be formatted for the view
        if ( this.estimatedCosts.sumOfEstimatedCosts !== undefined ) {
            this.sumOfEstimatedCostsFormatted = this.amountUtils.getFormattedAmount( this.estimatedCosts.sumOfEstimatedCosts );
        }
    }
}
